import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../../../../redux/selectors";

export const useKambiCategoryItems = () => {
  const [visibleCategories, setVisibleCategories] = useState([]);
  const [hiddenCategories, setHiddenCategories] = useState([]);

  const sportCategories = useSelector(MenuSelectors.sportCategories);
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );

  useEffect(() => {
    setVisibleCategories(
      sportCategories?.slice(
        0,
        numberOfDisplayedItems || sportCategories?.length
      )
    );
  }, [sportCategories, numberOfDisplayedItems]);

  useEffect(() => {
    setHiddenCategories(
      sportCategories?.filter(x => !visibleCategories.includes(x))
    );
  }, [sportCategories, visibleCategories]);

  return { visibleCategories, hiddenCategories, sportCategories };
};
